import { render, staticRenderFns } from "./kpiTemplate.vue?vue&type=template&id=68815cc1&"
import script from "./kpiTemplate.vue?vue&type=script&lang=js&"
export * from "./kpiTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports